<div class="text-center" *ngIf="data" >
    <div>
      <div  mat-dialog-content>
          <mat-icon [color]="data.color" *ngIf="data.icon">{{data.icon}}</mat-icon>
          <div style="font-weight: bold;
          font-size: 17px;
          margin-bottom: 2px;">{{data.title}}</div>
          <p class="mb-4 font-weight-600 font-size-14" > {{data.body}}</p>
              
      </div>   
      <div>
        <button style=" margin: 0px 4px;
        padding: 4px;
        padding-left: 14px;
        padding-right: 14px;
        border-radius: 4px;" *ngFor="let b of data.btns_lst" mat-outlined-button
          [ngStyle]="{
            'background-color': b.backgroundColor,
            'color': b.textColor,
          }"
          (click)="onBtnClick(b.cb_res)">{{b.title}}</button>
      </div> 
    </div>
</div>